import { Link } from "react-router-dom";

export const AuthLegalLine = ({ className = "" }) => (
  <div className={`text-[11px] text-[color:var(--text-muted)] ${className}`} data-testid="auth-legal-line">
    <Link to="/terms/planner" className="link-underline">Terms of Service</Link>
    <span className="mx-2">·</span>
    <Link to="/privacy" className="link-underline">Privacy Policy</Link>
  </div>
);
